import React from 'react'
import UnlockContentDialog from 'components/Display/UnlockContentDialog.js'
import useUserInfo from 'logic/Auth/useUserInfo.js'

const AuthProtection = ({WrappedComponent, ...props}) => {
    const {isLoggedIn, isLoading} = useUserInfo()

    return (
        <>
            {!isLoggedIn && !isLoading && <UnlockContentDialog />}
            <WrappedComponent {...props} />
        </>
    )
}

export default AuthProtection
